import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { offersAction } from 'store';
import { Images } from 'assets/images';
import { AVAILABLE, REQUESTED, GREEN_BACKGROUND } from 'utils/constant';
import { ROUTES } from 'utils/routeNames';
import { dateValidFormat } from 'utils/helpers';
import {
  CreateRequest,
  FullRequestBlock,
  NameAndAvailability,
  PlusIcon,
  QuestionOfferBlock,
  RequestBox,
  RequestName,
  RequestQuestionOffer,
  RequestStatus,
  RequestSubmitDate,
} from './styled';

export const RequestsBlock = () => {
  const { offers } = useSelector((state) => state.offersReducer);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const navigateToQuestion = () => {
    navigate(ROUTES.QUESTIONS);
  };

  const viewOfferHandler = (id) => {
    navigate(`${ROUTES.REQUESTS}/${id}`);
  };

  const viewQuestionsHandler = (element) => {
    const searchParams = new URLSearchParams();
    searchParams.append('title', element.title);
    searchParams.append('submitted', element.submitted);
    searchParams.append('status', element.status);
    navigate(`${ROUTES.VIEW_REQUEST}/${element.id}?${searchParams.toString()}`);
  };

  useEffect(() => {
    dispatch(offersAction.getOffers());
  }, []);

  return (
    <FullRequestBlock>
      {offers?.map((element) => (
        <RequestBox key={uuid()}>
          <NameAndAvailability>
            <RequestName>{element.title || 'Request'}</RequestName>

            <RequestSubmitDate>
              Submitted: {dateValidFormat(element.submitted)}
            </RequestSubmitDate>

            {element.status !== 2 && element.received ? (
              <RequestSubmitDate>
                Received: {dateValidFormat(element.received)}
              </RequestSubmitDate>
            ) : null}
          </NameAndAvailability>

          <RequestStatus className={element.status === 1 ? GREEN_BACKGROUND : null}>
            {element.status === 1 ? AVAILABLE : REQUESTED}
          </RequestStatus>

          <QuestionOfferBlock>
            {element.status !== 2 && element.received ? (
              <RequestQuestionOffer onClick={() => viewOfferHandler(element.id)}>
                View Offer
              </RequestQuestionOffer>
            ) : null}

            <RequestQuestionOffer onClick={() => viewQuestionsHandler(element)}>
              View Questions
            </RequestQuestionOffer>
          </QuestionOfferBlock>
        </RequestBox>
      ))}

      {offers?.length < 3 ? (
        <RequestBox onClick={navigateToQuestion}>
          <CreateRequest>
            <PlusIcon src={Images.AddRequestPlusIcon} />
          </CreateRequest>
        </RequestBox>
      ) : null}
    </FullRequestBlock>
  );
};
